module.exports = __webpack_public_path__ + "img/notes_002.f6ab8076.png";